import React from 'react';
import { CountdownBar } from '../components/artTherapy/CountdownBar';
import { Hero } from '../components/artTherapy/Hero';
import { StatsGrid } from '../components/artTherapy/StatsGrid';
import { PainPoints } from '../components/artTherapy/PainPoints';
import { AudienceFit } from '../components/artTherapy/AudienceFit';
import { FourSteps } from '../components/artTherapy/FourSteps';
import { ManualPages } from '../components/artTherapy/ManualPages';
import { Bundle } from '../components/artTherapy/Bundle';
import { PricingOffer } from '../components/artTherapy/PricingOffer';
import { Reviews } from '../components/artTherapy/Reviews';
import { GuaranteeSeal } from '../components/artTherapy/GuaranteeSeal';
import { FaqList } from '../components/artTherapy/FaqList';
import { ClosingCta } from '../components/artTherapy/ClosingCta';
import { SiteFooter } from '../components/artTherapy/SiteFooter';
import { OfferTimerProvider } from '../contexts/OfferTimerContext';
export function Landing() {
  return <OfferTimerProvider data-id="element-382" data-mp="2ajux3it2abs">
    <div className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-ink" data-id="element-383" data-mp="2ati6jcgu3ds">
      <CountdownBar data-id="element-384" data-mp="3tfa3dfl2a27w" />
      <main data-id="element-385" data-mp="3tes0w17t2rrj">
        <Hero data-id="element-386" data-mp="3tifu0z9c9c5q" />
        <StatsGrid data-id="element-387" data-mp="3tio6iq1jufge" />
        <PainPoints data-id="element-388" data-mp="3pegjqyenj9kt" />
        <ManualPages data-id="element-389" data-mp="3pfrkepcsw17p" />
        <AudienceFit data-id="element-390" data-mp="3pf9ojtu1vp0b" />
        <FourSteps data-id="element-391" data-mp="3pgku9z7236u2" />
        <Reviews data-id="element-392" data-mp="3kfwryhddn3kj" />
        <Bundle data-id="element-393" data-mp="3kgeyq7xo106p" />
        <PricingOffer data-id="element-394" data-mp="3kgygnonbfokq" />
        <GuaranteeSeal data-id="element-395" data-mp="3khhmw83lsoix" />
        <FaqList data-id="element-396" data-mp="l0ias5suh7pz" />
        <ClosingCta data-id="element-397" data-mp="l11iyusp0hqt" />
      </main>
      <SiteFooter data-id="element-398" data-mp="kz8cbfi2xxit" />
    </div>
    </OfferTimerProvider>;
}